interface ShapeRendererProps {
  width: number;
  height: number;
  strokeColor: string;
  render: (w: number, h: number) => JSX.Element;
}

const ShapeRenderer: React.FC<ShapeRendererProps> = ({
  width,
  height,
  strokeColor,
  render,
}) => {
  return (
    <svg
      className="absolute top-0 left-0"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
    >
      <g
        fill="white"
        stroke={strokeColor}
        strokeWidth={2}
        className="group-hover:stroke-gray-600 transition-colors ease-in-out duration-200"
      >
        {render(width, height)}
      </g>
    </svg>
  );
};

export default ShapeRenderer;
